export const projects = [
    {
        id: '01',
        slug: 'index',
        title: 'The Index',
        description:
            'This portfolio site itself — a 3D scene where project cards curve into a scrollable carousel. Built from scratch with Three.js and custom animation, without relying on a template.',
        enable: true,
        thumbnail: `/medias/projects/project-1/thumbnail.png`,
        medias: [
            { type: 'image', src: '/medias/projects/project-1/gallery-01.png' },
            { type: 'image', src: '/medias/projects/project-1/gallery-02.png' },
            { type: 'video', src: '/medias/projects/project-1/gallery-03.mov' }
        ],
        type: 'project',
        role: 'Development, Design',
        year: '2026',
        url: 'https://jiuan-wu.com'
        // color: '#000000'
    },
    {
        id: '02',
        slug: '02',
        title: 'Soon',
        description: '',
        enable: false,
        thumbnail: ``,
        medias: [],
        type: 'project',
        role: 'x',
        year: 'x',
        url: ''
        // color: '#a2a2a2'
    },
    {
        id: '03',
        slug: '3',
        title: 'soon',
        description: '',
        enable: false,
        thumbnail: ``,
        medias: [],
        type: 'project',
        role: 'x',
        year: 'x',
        url: ''
        // color: '#404040'
    },
    {
        id: '04',
        slug: '4',
        title: 'soon',
        description: '',
        enable: false,
        thumbnail: ``,
        medias: [],
        role: 'x',
        year: 'x',
        type: 'project',
        url: ''
        // color: '#d6d6d6'
    }
    // {
    //     id: '05',
    //     slug: '5',
    //     title: 'soon',
    //     description: '',
    //     enable: false,
    //     thumbnail: ``,
    //     medias: [],
    //     role: 'x',
    //     year: 'x',
    //     type: 'project',
    //     url: ''
    //     // color: '#000000'
    // }
]
